import { dlog, dLogTime, dLogTimeEnd } from "@shared/utility.js";
import { cfAccountHash } from "@shared/cloudflare.js";

const gImageCache = { };

function get(inSrc) {
    return gImageCache[inSrc];
}

function store(img, inSrc) {
    gImageCache[inSrc] = img;
}

function has(inSrc) {
    return gImageCache[inSrc] != null;
}

async function getLoadAndStoreURL(url) {
    const cacheKey = url;
    let cached = gImageCache[cacheKey];
    if (cached) {
        return cached;
    }
        
    dLogTime(`getLoadAndStoreURL: ${url}`);
    
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = url;
    
        img.onload = async () => {
            try {
                await img.decode();
                gImageCache[cacheKey] = img;
                dLogTimeEnd(`getLoadAndStoreURL: ${url}`);
                resolve(img);
            } catch (error) {
                reject(error);
            }
        };
    
        img.onerror = (error) => {
            reject(error);
        };
    });
}

// Like get, but can also load and store the image if not already present in the cache.
// Fetches from Cloudflare at the given params that are fed into Cloudflare's "flexible variants" system.
async function getLoadAndStoreCF(imageID, width, format="webp", quality=100, dpr=1) {
    const cfUrl = `https://imagedelivery.net/${cfAccountHash}/${imageID}/w=${width},format=${format},quality=${quality},dpr=${dpr}`;
    
    return getLoadAndStoreURL(cfUrl);
}

export  { get, store, has, getLoadAndStoreCF, getLoadAndStoreURL };